define('lq/licquidRuntimeSpa',[
    'lq',
    'underscore',
    'drops/action/action',
    'lq/runtimePiping',
    'lq/parameterShell',
    'lq/actionLoader',
    'lq/navigatorSpa',
    'lq/style',
    'lq/windowSize',
    'lq/responsive',
    'lq/services/application/applicationServiceFactory',
    'lq/validatorGateway',
    'lq/highlighter',
    'lq/layouting',
    'lq/javascript/polyfill'
], function (lq, _, Action, RuntimePiping, ParameterShell, ActionLoader, NavigatorSpa, Style, windowSize, responsive, applicationServiceFactory, validatorGateway, highlighter, layouting) {

    var deferredPrompt = null;
    if (!responsive.isPWA()) {
        // Running in Browser
        window.addEventListener('beforeinstallprompt', function (e) {
            deferredPrompt = e;
        });
    }

    var inIframe = function () {
        return window !== window.parent;
    };

    var LicquidRuntimeSpa = function () { };

    LicquidRuntimeSpa.prototype.start = function (setup) {
        lq.setIsInMockMode(setup.isInMockMode);
        if (setup.application.embedded) {
            window.parent.postMessage(JSON.stringify({
                eventName: 'LicquidLoaded'
            }), '*');
        }

        var self = this;
        windowSize.withOnChanged(function () {
            if (self.action) self.action.resize();
        });

        Style.defaultStyles = setup.application.styles.defaultStyles;
        Style.defaultMockStyles = setup.application.styles.defaultMockStyles;
        Style.mockMode = setup.isInMockMode;

        this.action = null;

        this.$app = setup.$el;
        this.$wrapper = $('<div class="licquid-action-wrapper" />')
            .appendTo(this.$app);
        this.$view = $('<div class="licquid-action-view" />')
            .appendTo(this.$wrapper);

        this.globalPiping = RuntimePiping.createRoot(setup.parameters.globals, setup.application, this.$app);
        this.globalPiping.navigator = NavigatorSpa.withLocalStorage(setup.action.id, this.globalPiping.url, this.openNewAction.bind(this));
        this.globalPiping.errorHandler.addListener(this.handleError.bind(this));
        this.globalPiping.runtime = this;

        if (validatorGateway.isEnabled()) {
            validatorGateway.publishEvent({
                type: 'LICQUID_RUNTIME_LOADED',
                globalPiping: this.globalPiping,
                isInMockMode: lq.isInMockMode()
            });
        } else {
            validatorGateway.whenEnabled(function () {
                validatorGateway.publishEvent({
                    type: 'LICQUID_RUNTIME_LOADED',
                    globalPiping: self.globalPiping,
                    isInMockMode: lq.isInMockMode()
                });

                if (self.action !== null) {
                    validatorGateway.registerListener(self.action.instanceId, self.receiveMessage.bind(self));

                    validatorGateway.publishEvent({
                        type: 'ACTION_INSTANCE_LOADED',
                        action: self.action,
                        canReload: false
                    });
                }
            });
        }

        this.globalServices = _.map(setup.application.services, function (service) {
            return applicationServiceFactory.createService(service);
        });
        _.forEach(this.globalServices, function (globalService) {
            globalService.initialize(self);
        });

        this.application = setup.application;

        this.actionLoader = new ActionLoader(this.globalPiping.url);
        this.actionLoader.addListener(this.showAction.bind(this));

        this.globalPiping.busyIndicator.show();
        this.openNewAction(setup.action.id, setup.parameters.globals, setup.parameters.locals);

        this.globalPiping.deferredPrompt = deferredPrompt;
    };

    LicquidRuntimeSpa.prototype.reorient = function () { // After travelling in the history stack
        const positionLastShown = Number( // If none, then zero
            sessionStorage.getItem('positionLastShown' ));
        var position = history.state ? history.state.position : null; // Absolute position in stack
        if (position === null ) { // Meaning a new entry on the stack
            position = positionLastShown + 1; // Top of stack
            var s = history.state ?? { position: 0 };
            s.position = position;
            // (1) Stamp the entry with its own position in the stack
            history.replaceState( s, /*no title*/'' );
        }

        // (2) Keep track of the last position shown
        sessionStorage.setItem('positionLastShown', String(position) );

        // (3) Discover the direction of travel by comparing the two
        const direction = Math.sign( position - positionLastShown );
        return direction;
        // One of backward (-1), reload (0) and forward (1)
    };

    LicquidRuntimeSpa.prototype.showAction = function (actionId, setup, parameters, state) {
        this.reorient()
        $.extend(this.globalPiping.application, setup.application);

        if(setup.view.insertionPoint) {
            var index = this.insertionPoints.indexOf(setup.view.insertionPoint);
            this.insertionPoints = this.insertionPoints.slice(0, index + 1);
            this.insertionPoints = this.insertionPoints
                .concat(_.map(setup.view.actions, function(action) {
                    return action.action.id;
                }));

            this.action.setContent(setup.view.actions, parameters.locals, setup.view.insertionPoint);

            this.updateHistory(setup, _.last(setup.view.actions).action.id, parameters, state);
        } else {
            this.insertionPoints = _.map(setup.view.actions, function(action) {
                return action.action.id;
            });

            var actionData = setup.view.actions[0].action;
            var systemParameters = setup.view.actions[0].systemParameters;
            var localParameters = setup.view.actions.length > 1 ? {} : parameters.locals;

            var action = new Action(actionData.view, this.globalPiping.application.options);
            action.loadData(actionData);
            action.piping = this.globalPiping.createChildPiping(actionData, action, localParameters, systemParameters, this.$wrapper, this.$view, !this.action && window.performance.navigation.type == window.performance.navigation.TYPE_RELOAD);
            action.globals = _.clone(parameters.globals);
            action.locals = _.clone(parameters.locals);

            var layout = responsive.getCurrentLayout(action);
            layouting.applyLayout(this.$view, layout);

            var notInsideIFrame = window.top.location === window.location;
            action.applyLayout(layout, notInsideIFrame);

            if (action.shouldUseWidthOfLayout()) {
                action.data.size.x = layout.resolutionX;
            }

            var self = this;
            action.piping.viewTransitionManager.scheduleViewTransition(
                function () {
                    var promise = self.startActionRender(action, setup, parameters);
                    self.postActionRender(action, setup, parameters, state)
                    return promise;
                })
                .then(function () {
                    action.startEventing();
                });
        }

        this.currentActionId = actionId;
    };

    LicquidRuntimeSpa.prototype.startActionRender = function (action, setup, parameters) {
        // todo svb SPA viewport should only be set once (but what with "growable" actions?)
        return action.createAndRenderDrops($('#viewport'))
            .then(function () {
                action.setContent(setup.view.actions.slice(1), parameters.locals);
            });
    };

    LicquidRuntimeSpa.prototype.postActionRender = function (action, setup, parameters, state) {
        if (this.action) {
            if(validatorGateway.isEnabled()) {
                validatorGateway.unregisterListener(this.action.instanceId);

                validatorGateway.publishEvent({
                    type: 'ACTION_INSTANCE_UNLOADING',
                    action: this.action
                });
            }

            this.action.piping.cleanUp();
            this.action.unsubscribeEventHandlersRecursive();

            this.updateHistory(setup, _.last(setup.view.actions).action.id, parameters, state);
        } else {
            window.history.replaceState({
                actionId: _.last(setup.view.actions).action.id,
                globals: parameters.globals,
                locals: parameters.locals,
                position: window.history.state.position
            }, '', this.application.hideUrl ? lq.getTenantUrl('') : window.location.href);
        }

        this.$wrapper.scrollTop(0);
        this.action = action;
        this.action.piping.busyIndicator.forceHide();

        if(validatorGateway.isEnabled()) {
            validatorGateway.registerListener(action.instanceId.toString(), this.receiveMessage.bind(this));
            validatorGateway.publishEvent({
                type: 'ACTION_INSTANCE_LOADED',
                action: action,
                canReload: setup.view.actions.length === 1
            });
        }

        if (inIframe()) {
            window.parent.postMessage(JSON.stringify({
                eventName: 'EmbeddedActionLoaded',
                sizeX: action.data.size.x,
                sizeY: action.data.size.y
            }), window.location.protocol + '//' + window.location.host);
        }

        var self = this;
        this.action.subscribeEventHandler($(window), 'popstate', function (ev) {
            var e = ev.originalEvent;
			if (e.state === null) return;  //= null for <a href="#">

            if (!self.action.getEventDataFor('backClicked').enabled) {
                self.openNewAction(e.state.actionId, e.state.globals, e.state.locals, { ignoreHistory: true });
            } else {
                var direction = self.reorient();
                if (direction != 1) { // we moved back
                    self.action.triggerEventIfEnabled('backClicked');
                    self.updateHistory(setup, self.action.data.id, {locals: e.state.locals, globals: e.state.globals}, e.state);
                } else {
                    self.openNewAction(e.state.actionId, e.state.globals, e.state.locals, { ignoreHistory: true });
                }
            }
        });
    };

    LicquidRuntimeSpa.prototype.updateGlobalParameters = function (newCollection) {
        var globals = this.globalPiping.parameters.globals;
        var newKeys = _.keys(newCollection);
        _.each(newKeys, function (newKey) {
            var newValue = newCollection[newKey];
            if (!globals.parameterExists(newKey) || globals.getValue(newKey) !== newValue)
                globals.setValue(newKey, newValue);
        });
        _.each(_.keys(globals.getAll()), function (key) {
            if (!_.includes(newKeys, key))
                globals.remove(key);
        })
    };

    LicquidRuntimeSpa.prototype.updateHistory = function (setup, actionId, parameters, state) {
        this.updateGlobalParameters(parameters.globals);
        if (!state || !state.ignoreHistory) {
            var pageUrl = setup.friendlyName
                ? setup.friendlyName
                : 'LicquidAction/Get/' + actionId;

            var currentParameters = {};
            if (_.keys(parameters.globals).length)
                currentParameters.globals = JSON.stringify(parameters.globals);
            if (_.keys(parameters.locals).length)
                currentParameters.parameters = JSON.stringify(parameters.locals);

            var currentUrl = this.application.hideUrl
                ? lq.getTenantUrl('')
                : this.globalPiping.url.prepare(lq.getTenantUrl(pageUrl), currentParameters);

            window.history.pushState({
                    actionId: actionId,
                    globals: parameters.globals,
                    locals: parameters.locals,
                    position: this.getPos()
                },
                '',
                currentUrl);
        }
    };

    LicquidRuntimeSpa.prototype.getPos = function () {
        var position = sessionStorage.getItem('positionLastShown');
        if (!position) {
            position = 0;
        } else {
            position++;
        }
        sessionStorage.setItem('positionLastShown', position);
        return position;
    };

    LicquidRuntimeSpa.prototype.receiveMessage = function (message) {
        switch (message.type) {

            case 'RELOAD_ACTION_INSTANCE':
                this.reloadAction();
                break;

            case 'HIGHLIGHT_ACTION_INSTANCE':
                highlighter.highlight(this.$wrapper);
                break;

        }
    };

    LicquidRuntimeSpa.prototype.openNewAction = function (actionId, globals, locals, state) {
        this.actionLoader.load(actionId, globals, locals, state, this.insertionPoints);
    };

    LicquidRuntimeSpa.prototype.handleError = function (errorArgs) {
        if (this.action) this.action.error(errorArgs);
    };

    LicquidRuntimeSpa.prototype.reloadAction = function() {
        this.openNewAction(this.currentActionId, this.action.globals, this.action.locals, { ignoreHistory: true });
    };

    return LicquidRuntimeSpa;
});
